<template>
  <el-container class="EstmationSelectDialog">
    <el-main class="p-0">
      <div class="flex">
        <div class="lt-area flex-auto">
          <el-input
            class="input-with-select"
            size="mini"
            v-model="searchWord"
            :placeholder="placeholder"
            @keydown.enter.native="handleClickFilter"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleClickFilter" />
          </el-input>
          <div class="right-search-head inline" style="margin-left: 10px">
            <div class="inline">
              <APeriodSelector 
                ref="period" 
                value="1m"
                @change="handleChangePeriod" 
              />
            </div>
            <div class="inline">
              <el-button
                type="primary"
                size="mini"
                round
                v-shortkey="['f5']"
                @shortkey.native="handleClickSearch"
                @click="handleClickSearch"
              >{{ $t("button.search") }} (F5)</el-button>
            </div>
          </div>
        </div>
      </div>
      <div style="min-height:200px;">
        <ATable 
          ref="table" 
          :loading="loading"
          :data="filterItemsEstimation"
          :search_field="search_field"
          hideButtonInsert
          hideTopPanel
          hide-pagination
          border
          @row-click="handleClickRow"
        >
          <el-table-column 
            type="index" 
            label="No" 
            :index="handleIndex" 
            :width="$width.index" 
          />
          <el-table-column 
            prop="estimate_date" 
            label="견적일" 
            :width="$width.date" 
          />
          <el-table-column 
            prop="code" 
            label="견적번호" 
            width="85" 
          />
          <el-table-column 
            prop="customer_name" 
            label="거래처" 
            width="100" 
            show-overflow-tooltip
          />
          <el-table-column 
            prop="product_name" 
            label="품목" 
            show-overflow-tooltip 
          />
          <el-table-column
            prop="price"
            label="견적가"
            width="100"
            :formatter="util.numberFormat"
            class-name="cell-number"
          />
          <el-table-column 
            prop="status_flag" 
            label="상태" 
            width="80" 
            :formatter="resolveStatus" 
          />
          <el-table-column 
            prop="created_user_name"
            label="견적인"
            :width="$width.username"
          />
          <div slot="right-bottom" style="height:20px;">
            <el-button class="close-button" @click="handleClickClose">{{$t('button.close')}} (Esc)</el-button>
          </div>
        </ATable>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import {} from "vuex";

export default {
  name: "EstmationSelectDialog",
  components: {},
  data() {
    return {
      searchWord: null,
      placeholder: "견적번호, 거래처, 품목",
      search_field: ["code", "customer_name", "product_name"],
      items: [],
      fixedSearchWord: "",
      loading: false,
      period: {},
      statuses: [
        { value: "0", label: "진행" },
        { value: "1", label: "수주" },
        { value: "2", label: "취소" },
      ],
    };
  },
  computed: {
    is_new() {
      return this.data.id < 1;
    },
    filterItemsEstimation() {
      return this.util.filterMultiFields(
        this.items,
        this.search_field,
        this.fixedSearchWord
      );
    },    
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickRow(data) {
      this.$emit("select", data);
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    resolveStatus(row) {
      let ret = "";
      switch (row["status_flag"]) {
        case "0":
          ret = "진행";
          break;
        case "1":
          ret = "수주";
          break;
        case "2":
          ret = "취소";
          break;
      }
      return ret;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.api.listEstimation(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "견적", res.message);
          return;
        }
        this.items = res.data;
        for (let i = 0; i < this.items.length; ++i) {
          this.dataArrange(i);
        }
      });
    },
    dataArrange(index) {
      this.items[index].amount = 0;
      this.items[index].tax = 0;
      this.items[index].cost = 0;
      this.items[index].supply_price = 0;
      for (let j = 0; j < this.items[index].details.length; ++j) {
        this.sumCalculation(index, j);
      }
      this.productNaming(index);
    },
    sumCalculation(index, j) {
      this.items[index].amount += this.items[index].details[j].amount;
      this.items[index].tax += this.items[index].details[j].tax;
      this.items[index].cost += this.items[index].details[j].cost;
      this.items[index].supply_price += this.items[index].details[
        j
      ].supply_price;
    },
    productNaming(index) {
      if (this.items[index].details.length > 1) {
        this.items[index].product_name = this.items[index].details[0].product_name + " 외 " + (this.items[index].details.length - 1) + "건";
      } else {
        this.items[index].product_name = this.items[index].details[0].product_name;
      }
    },
    handleClickFilter() {
      this.fixedSearchWord = this.searchWord;
    },
    handleClickClose() {
      this.$emit('completed');
    },
  },
};
</script>
